import React from 'react';
import './App.css';
import social from './social.jpg';
import empty from './empty.jpg';

function App() {
  return (
    <div className="App">
      <div className='heading'>
        <h1>Become Rich and Find out the secret of making money like a millionaire.</h1>
      </div>
      <div className='second'>
        <h2>How money is connected to positivity and Motivation and why do you need money to stay positive and motivated most of the time?</h2>
        <p>
        Money solves 99% of your problems, which means it saves 99% of your time, leaving you with 1% of your problems to solve, you have 100% of your time to solve your 1% of problems... Doesn't this mean that money solves 100% of your problems? This is crazy 99% of your problems that money can solve. Doesn’t it mean that most of your problem is solve and now you will get positive vibes and feel motivated? 
        </p>
      </div>
      <div className='second'>
        <p>
        Why did I say so? If you are having a bad time and I am sure that most of your problem is related to money and when you have a problem it’s natural that you will feel powerless and negative. Let’s find out why if you are not sure.
        </p>
        <a href='https://bit.ly/3j2PQvG'>
          <img src={empty} alt='empty'/>
        </a>
        
        <p className='major'>
        I have some examples here which is a major problem that occurs in everyone’s life:
        </p>
        <ul>
          <li>
          If your spouse is unhappy with your financial position with your marriage. You can resolve this issue with money and live your life full of happiness.
          </li>
          <li>
          you need to send your kids off to college and don't want them to spend time in a deadbeat community college. You can solve this problem with money too.
          </li>
          <li>
          If you are homeless and don't have a house. This is a big one. Having own is everyone wants. If you have the money you can buy a house for yourself.
          </li>
          <li>
          you enjoy luxury, go travel, eat out, buy fancy clothes. You can do this with money.
          </li>
          <li>
          Money can buy food for you. 
          </li>
          <li>If someone is dying money can even pay for treatment to stop that as well.</li>
          <li>
          Money can always buy a better version of something that might be uncomfortable ie flying first class instead of economy
          </li>
        </ul>
      </div>
      <div className='seconds'>
        <h2>
        The Answer is Here
       </h2>
       <a href='https://bit.ly/3j2PQvG'>
         <img src={social} alt='social'/>
       </a>
       
       <p>As I told you already that money buys happiness for you. Why I told you all of this. Because I have something for you which can take away most of your money problem. You can live your life as you want. You will know why most of the people are rich? What is the most efficient way to earn money at this age? If you really want to get rich and solve most of your problem click the Button or any image on this page to know what is the secret to making money. </p>
       <div className='btn'>
         <a href='https://bit.ly/3j2PQvG'>
           <button>Yes, I want to Know</button>
         </a>
       </div>
       
      </div>      
    </div>
  );
}

export default App;
